import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Configuration } from 'src/assets/config/config';


@Injectable({
  providedIn: 'root'
})
@Injectable()
export class ConfigService {

  config : Configuration;

  constructor(private _http: HttpClient) {

  }

  public load(configPath: string): Promise<any> {
    return new Promise((resolve) => {
      this._http.get(configPath)
        .subscribe(config => {
          console.log(config);
          this.config =  Object.assign(new Configuration(), config);
          resolve();
        });
    })
  }
}
